import axios from 'axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    thirteenMonthPays: {},
    isLoadingTable: false,
    showDeleteModal: false,
    thirteenMonthPay: {}
}

const mutations = {
    getPaginatedThirteenMonthPays(state, payload) {
        state.isLoadingTable = true
        axios.get(`api/thirteenmonthpays/page=${payload.page}&pageSize=${payload.pageSize}/${payload.year}/${payload.query}`).then(response => {
            response.data.data.forEach(d => {
                d.dateCreated = moment(d.dateCreated).format('MM/DD/YYYY HH:ss')
                d.amount = numeral(d.amount).format('0,0.00')
            })
            state.thirteenMonthPays = response.data
        }).catch(error => {
            // eslint-disable-next-line no-console
            console.log(error)
        }).then(() => {
            state.isLoadingTable = false
        })
    },
    openDeleteModal(state, payload) {
        state.showDeleteModal = payload.showDeleteModal
        if (payload.thirteenMonthPay) {
            state.thirteenMonthPay = payload.thirteenMonthPay
        } else {
            state.thirteenMonthPay = {}
        }
    }
}

const actions = {
    getPaginatedThirteenMonthPays({
        commit
    }, payload) {
        commit('getPaginatedThirteenMonthPays', payload)
    },
    openDeleteModal({
        commit
    }, payload) {
        commit('openDeleteModal', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}